const FORBIDDEN_FILES_TYPES = ['', 'text/plain', 'text/csv'];

export { FORBIDDEN_FILES_TYPES };
